// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hOOku-Card_root{border-radius:var(--card-xl,2rem);display:flex;flex-direction:column;background-color:var(--bg,#fff);box-sizing:border-box}.QLx2a-Card_padding_blue{padding:var(--blue,2.6666666667rem)}.JeLfo-Card_padding_orange{padding:var(--orange,1.3333333333rem)}.JCcyD-Card_radius_xl{border-radius:var(--card-xl,2rem)}.J7pRC-Card_radius_m{border-radius:var(--card-m,1.3333333333rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "hOOku-Card_root",
	"padding_blue": "QLx2a-Card_padding_blue",
	"padding_orange": "JeLfo-Card_padding_orange",
	"radius_xl": "JCcyD-Card_radius_xl",
	"radius_m": "J7pRC-Card_radius_m"
};
export default ___CSS_LOADER_EXPORT___;
